const { useRenderTimeMeasurements } = require('utils/framework/hooks/useRenderTimeMeasurements');
const wrapHOCComponent = require('utils/framework/wrapHOCComponent').default;
const React = require('react');

/**
 * @description HOC to measure render time metrics of `WrappedComponent`.
 *
 * @param {React.Component} WrappedComponent Component whose performance to measure.
 *
 * @return {React.Component} A new HOC instance.
 */
function withRenderTimeMeasurements(WrappedComponent) {
    const RenderTimeMeasurements = props => {
        useRenderTimeMeasurements(WrappedComponent, props.stackId);

        if (WrappedComponent.isComponent) {
            const { stackId, ...restProps } = props;

            return <WrappedComponent {...restProps} />;
        } else {
            return <WrappedComponent {...props} />;
        }
    };

    return wrapHOCComponent(RenderTimeMeasurements, 'RenderTimeMeasurements', arguments);
}

module.exports = { withRenderTimeMeasurements };
